import { getAuthRole, getAuthUserId } from "./authSession";

/** Staff who may change client email or delete a client business (plus admins). */
export const CLIENT_SENSITIVE_EDIT_EMPLOYEE_IDS = [
  "079ae1a9-b9f1-4939-89c9-63c74f30dd47",
  "1daa441a-99b6-4752-b9e7-f189b6f8dc17",
  "2301ab0e-a588-40b5-8e77-3e0b31de865c",
  "79d3e09b-1ce0-4c01-9bac-1a9a0dfd4ae3",
];

export function canChangeClientEmailOrDeleteBusiness(
  userId = getAuthUserId(),
  role = getAuthRole(),
) {
  const normalizedRole = String(role || "")
    .trim()
    .toLowerCase();
  if (normalizedRole === "admin") return true;
  return CLIENT_SENSITIVE_EDIT_EMPLOYEE_IDS.includes(
    String(userId || "").trim(),
  );
}
